import { FormNavigation } from '~shared/ui/form-navigation';
import type { FormNavigationSection } from '~shared/ui/form-navigation';

import {
  PARTNER_APPLICATION_NAV_SECTIONS,
  PARTNER_APPLICATION_NAV_STEPS,
  PartnerApplicationNavSectionId,
  PartnerApplicationNavStepId,
} from '../lib/partner-application-nav-step';

type NavStep = { id: PartnerApplicationNavStepId; label: string };

const BUSINESS_INFO_ITEMS: NavStep[] = [
  { id: PARTNER_APPLICATION_NAV_STEPS.businessType, label: 'Business type' },
  {
    id: PARTNER_APPLICATION_NAV_STEPS.businessDetails,
    label: 'Business details',
  },
  {
    id: PARTNER_APPLICATION_NAV_STEPS.registeredAddress,
    label: 'Registered business address',
  },
  {
    id: PARTNER_APPLICATION_NAV_STEPS.mainOfficeAddress,
    label: 'Main office address',
  },
  {
    id: PARTNER_APPLICATION_NAV_STEPS.businessDocuments,
    label: 'Business documents',
  },
  {
    id: PARTNER_APPLICATION_NAV_STEPS.bankAccount,
    label: 'Bank account info',
  },
];

const SECTIONS: {
  id: PartnerApplicationNavSectionId;
  title: string;
  items?: NavStep[];
}[] = [
  {
    id: PARTNER_APPLICATION_NAV_SECTIONS.businessInfo,
    title: 'BUSINESS INFO',
    items: BUSINESS_INFO_ITEMS,
  },
  { id: PARTNER_APPLICATION_NAV_SECTIONS.stores, title: 'STORES' },
  { id: PARTNER_APPLICATION_NAV_SECTIONS.agents, title: 'AGENTS' },
  { id: PARTNER_APPLICATION_NAV_SECTIONS.finish, title: 'FINISH APPLICATION' },
];

type PartnerApplicationFormNavigationProps = {
  activeStepId?: PartnerApplicationNavStepId;
  activeSectionId?: PartnerApplicationNavSectionId;
};

export const PartnerApplicationFormNavigation = ({
  activeStepId,
  activeSectionId,
}: PartnerApplicationFormNavigationProps) => {
  const sections: FormNavigationSection[] = SECTIONS.map((section) => {
    const isActiveSection = activeSectionId === section.id;
    const isExpanded = isActiveSection && section.items !== undefined;

    return {
      id: section.id,
      title: section.title,
      items: isExpanded
        ? section.items?.map((item) => ({
            ...item,
            isActive: item.id === activeStepId,
          }))
        : undefined,
      isActive: isActiveSection && (!isExpanded || !activeStepId),
    };
  });

  return <FormNavigation sections={sections} />;
};
